export default __webpack_public_path__ + "static/media/truck_1_2.40a25933.svg";